import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Don't clear tokens or redirect during auth callback - let the callback handle it
      const isAuthCallback = window.location.pathname.includes('/auth/callback') || 
                             window.location.hash.includes('session_id');
      if (!isAuthCallback) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        if (!window.location.pathname.includes('/login') && 
            !window.location.pathname.includes('/register') && 
            window.location.pathname !== '/') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export default API;
